export default {
  meta: {
    title: '行业库',
  }
};
